<template>
  <div>
    <el-dialog
      title="数据源配置"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="筛选客户" name="filter">
          <el-form
            ref="filterForm"
            :model="filterForm"
            :rules="filterRules"
            label-position="top"
          >
            <div class="form-label">
              <span class="required-asterisk">*</span>筛选条件
            </div>
            <el-row :gutter="16">
              <el-col :span="5">
                <el-form-item label="企业规模:" prop="enterpriseScale">
                  <el-select
                    v-model="filterForm.enterpriseScale"
                    multiple
                    collapse-tags
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in enterpriseScaleOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="柴油估算:" prop="dieselEstimate">
                  <el-select
                    v-model="filterForm.dieselEstimate"
                    multiple
                    collapse-tags
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in dieselEstimateOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="省市区:" prop="provCityCounty">
                  <el-cascader
                  style="width: 100%;"
                    :options="areaListPr"
                    v-model="filterForm.provCityCounty"
                    :props="propsData()"
                    collapse-tags
                    clearable></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-button type="primary" @click="calculateImpact" :loading="calculateLoading" style="margin-top: 45px;" class="calculate-btn">测算</el-button>
              </el-col>
            </el-row>
            <div class="form-label">
              <span class="required-asterisk">*</span>调整影响
            </div>
            <el-table :data="impactData" border stripe style="width: 100%;" class="impact-table">
              <el-table-column
                prop="eligibleCustomers"
                label="符合条件客户"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="comparedToCurrent"
                label="较当前客户"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="coverProvince"
                label="覆盖省份"
                align="center"
              ></el-table-column>
            </el-table>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="filterForm.remark"
                type="textarea"
                :rows="4"
                placeholder="请输入备注"
                maxlength="1000"
                show-word-limit
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <div class="note-text">
              注:列表数据实时更新,始终展示来自配置数据源的最新生效结果
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="历史记录" name="history">
          <el-table :data="historyData" :max-height="400" stripe border>
            <el-table-column
              type="index"
              width="50"
              align="center"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="operationTime"
              label="操作时间"
              align="center"
              width="170"
            ></el-table-column>
            <el-table-column
              prop="operator"
              label="操作人员"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="filterConditions"
              label="筛选条件"
              align="center"
              min-width="400"
            >
              <template slot-scope="scope">
                <div style="white-space: pre-line; text-align: left;padding: 0 20px;">{{ scope.row.filterConditions }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="executionStatus"
              label="执行状态"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="adjustImpact"
              label="调整影响"
              align="center"
              min-width="250"
            >
              <template slot-scope="scope">
                <div style="white-space: pre-line; text-align: left;padding: 0 20px;">{{ scope.row.adjustImpact }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              align="center"
              min-width="150"
            ></el-table-column>
          </el-table>
          <div class="block" v-if="historyTotal > 0">
            <el-pagination
              @current-change="handleHistoryPageChange"
              :current-page.sync="historyCurrentPage"
              :page-size="historyPageSize"
              layout="prev, pager, next, jumper"
              :total="historyTotal"
              style="margin: 10px auto; text-align: center"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" v-if="activeTab === 'filter'">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">立即执行</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from 'api/freight'
import Util from 'utils/util'
import { mergeTree } from '@/utils/tools'

export default {
  data() {
    return {
      dialogVisible: true,
      activeTab: 'filter',
      areaListPr: [],
      filterForm: {
        enterpriseScale: [],
        dieselEstimate: [],
        provCityCounty: [],
        remark: ''
      },
      filterRules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      enterpriseScaleOptions: [
        { label: '1辆', value: '1' },
        { label: '2辆', value: '2' },
        { label: '3辆', value: '3' },
        { label: '4辆', value: '4' }
      ],
      dieselEstimateOptions: [
        { label: '1-2吨', value: '1' },
        { label: '2-3吨', value: '2' },
        { label: '3-5吨', value: '3' },
        { label: '5吨以上', value: '5' }
      ],
      impactData: [
        {
          eligibleCustomers: '+0',
          comparedToCurrent: '+0',
          coverProvince: '0个'
        }
      ],
      historyData: [],
      historyCurrentPage: 1,
      historyPageSize: 10,
      historyTotal: 0,
      calculateLoading: false,
      submitLoading: false
    }
  },
  mounted() {
    this.loadHistory()
    this.getPrInter()
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'history') {
        this.loadHistory()
      }
    },
    calculateImpact() {
      // 开始loading
      this.calculateLoading = true
      
      // 处理省市区数据转换
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.filterForm.provCityCounty && this.filterForm.provCityCounty.length > 0) {
        this.filterForm.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      const params = {
        vehicleCountSettings: this.filterForm.enterpriseScale || [],
        oilConsumptionSettings: this.filterForm.dieselEstimate || [],
        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes
      }
      
      // 调用测算接口
      http.calculation(params).then(e => {
        if (e.code == 200 && e.data) {
          this.impactData = [{
            eligibleCustomers: `+${e.data.conformCount || 0}`,
            comparedToCurrent: `+${e.data.increCount || 0}`,
            coverProvince: `${e.data.provCount || 0}个`
          }]
        } else {
          this.$message({
            message: e.message || '测算失败',
            type: 'error'
          })
        }
      }).catch(err => {
        this.$message({
          message: '测算接口调用失败',
          type: 'error'
        })
        console.error('测算接口调用失败:', err)
      }).finally(() => {
        // 结束loading
        this.calculateLoading = false
      })
    },
    loadHistory() {
      const params = {
        page: this.historyCurrentPage,
        pageSize: this.historyPageSize
      }
      
      // 调用历史记录接口
      http.findRecordPage(params).then(e => {
        if (e.code == 200 && e.data && e.data.dataList) {
          // 将接口返回的数据映射到表格需要的格式
          this.historyData = e.data.dataList.map(item => {
            // 拼接筛选条件，只显示有值的项
            const filterConditions = [
              item.vehicleCountSetting ? `企业规模: ${item.vehicleCountSetting}` : null,
              item.oilConsumptionSetting ? `柴油估算: ${item.oilConsumptionSetting}` : null,
              item.districts ? `省市区: ${item.districts}` : null
            ].filter(Boolean).join('\n')

            // 拼接调整影响，即使值为0也显示
            const adjustImpact = [
              `符合条件客户: +${item.conformCount || 0}`,
              `较当前客户: ${item.increCount >= 0 ? '+' : ''}${item.increCount || 0}`,
              `覆盖省份: ${item.provCount || 0}个`
            ].join('\n')

            // 格式化操作时间
            let operationTime = ''
            if (item.createTime) {
              operationTime = Util.format(new Date(item.createTime * 1).getTime(), 'yyyy-MM-dd hh:mm:ss')
            }

            return {
              operationTime: operationTime,
              operator: item.createUser || '',
              filterConditions: filterConditions,
              executionStatus: '执行成功', // 接口未返回，默认设为执行成功
              adjustImpact: adjustImpact,
              remark: item.remark || ''
            }
          })
          // 如果接口返回了总数，使用接口返回的值，否则使用当前列表长度
          this.historyTotal = e.data.total || e.data.dataList.length || 0
        } else {
          this.historyData = []
          this.historyTotal = 0
          if (e.message) {
            this.$message({
              message: e.message,
              type: 'warning'
            })
          }
        }
      }).catch(err => {
        this.$message({
          message: '历史记录加载失败',
          type: 'error'
        })
        console.error('历史记录接口调用失败:', err)
        this.historyData = []
        this.historyTotal = 0
      })
    },
    handleHistoryPageChange(index) {
      this.historyCurrentPage = index
      this.loadHistory()
    },
    handleSubmit() {
      this.$refs.filterForm.validate(valid => {
        if (valid) {
          // 开始loading
          this.submitLoading = true
          
          // 处理省市区数据转换
          let provCodes = []
          let cityCodes = []
          let countyCodes = []

          if (this.filterForm.provCityCounty && this.filterForm.provCityCounty.length > 0) {
            this.filterForm.provCityCounty.forEach(item => {
              if (item && item.length > 0) {
                // 根据长度决定放到哪个级别，只添加最后一项
                if (item.length === 1) {
                  provCodes.push(item[0])
                } else if (item.length === 2) {
                  cityCodes.push(item[1])
                } else if (item.length === 3) {
                  countyCodes.push(item[2])
                }
              }
            })
          }

          const params = {
            vehicleCountSettings: this.filterForm.enterpriseScale || [],
            oilConsumptionSettings: this.filterForm.dieselEstimate || [],
            provCodes: provCodes,
            cityCodes: cityCodes,
            countyCodes: countyCodes,
            remark: this.filterForm.remark
          }
          
          // 调用立即执行接口
          http.execute(params).then(e => {
            if (e.code == 200) {
              this.$message({
                message: '数据源配置成功',
                type: 'success'
              })
              this.$emit('closeTask', true)
            } else {
              this.$message({
                message: e.message || '执行失败',
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: '执行接口调用失败',
              type: 'error'
            })
            console.error('执行接口调用失败:', err)
          }).finally(() => {
            // 结束loading
            this.submitLoading = false
          })
        }
      })
    },
    close() {
      this.$emit('closeTask', false)
    },
    filterMethod(value) {
      return http
          .getCountyAreaListBySearch({keyword: value})
          .then(({data}) => {
            if (data.length !== 0) {
              const oldList = this.areaListPr || []
              const newList = data || []
              this.areaListPr = mergeTree(oldList, newList)
              return true // 允许 filter
            }
            return false // 阻止 filter
          })
    },
    async getPrInter() {
      http
          .getCountyAreaListBySearch({keyword:''})
          .then(({data}) => {
            this.areaListPr = data
          })
    },
    propsData() {
      return {
        lazy: false,
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.block {
  display: flex;
  padding: 5px 0;
  .center {
    margin: 10px auto;
  }
}

/deep/ .el-dialog__body {
  padding: 10px 20px 0px 20px !important;
}

/deep/ .el-form-item {
  margin-bottom: 20px;
}

/deep/ .el-form-item__content {
  width: 100%;
  box-sizing: border-box;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
.form-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-bottom: 15px;
  font-weight: normal;
  padding: 0;
}

.required-asterisk {
  color: #F56C6C;
  margin-right: 4px;
}

.impact-table {
  margin-bottom: 20px;
}

/deep/ .el-table {
  width: 100% !important;
  box-sizing: border-box;
}

/deep/ .el-textarea {
  width: 100%;
}

/deep/ .el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

/deep/ .el-tabs__header {
  margin: 0 0 20px 0 !important;
  padding: 0 !important;
}

/deep/ .el-tabs__item {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.dialog-footer .el-button {
  margin-left: 8px;
}

.dialog-footer .el-button:first-child {
  margin-left: 0;
}

.note-text {
  font-size: 12px;
  color: #F56C6C;
  margin-bottom: 20px;
  line-height: 20px;
}

</style>

